import { setVisibleRemoteParticipants } from '../filmstrip/actions.any';
import { TILE_VIEW_PARTICIPANT } from '../filmstrip/constants';
import { isTileViewModeDisabled } from '../filmstrip/functions.any';
import { SET_FILMSTRIP_VIEW_MODE, SET_TILE_VIEW, SET_TILE_VIEW_MODE, VIRTUAL_SCREENSHARE_REMOTE_PARTICIPANTS_UPDATED } from './actionTypes';
import { shouldDisplayTileView } from './functions';
/**
 * Creates a (redux) action which signals that the list of known remote virtual screen share participant ids has
 * changed.
 *
 * @param {string} participantIds - The remote virtual screen share participants.
 * @returns {{
 *     type: VIRTUAL_SCREENSHARE_REMOTE_PARTICIPANTS_UPDATED,
 *     participantIds: Array<string>
 * }}
 */
export function virtualScreenshareParticipantsUpdated(participantIds) {
    return {
        type: VIRTUAL_SCREENSHARE_REMOTE_PARTICIPANTS_UPDATED,
        participantIds
    };
}
/**
 * Creates a (redux) action which signals to set the UI layout to be tiled view
 * or not.
 *
 * @param {boolean} enabled - Whether or not tile view should be shown.
 * @returns {{
 *     type: SET_TILE_VIEW,
 *     enabled: ?boolean
 * }}
 */
export function setTileView(enabled) {
    return (dispatch, getState) => {
        const tileViewDisabled = isTileViewModeDisabled(getState());
        !tileViewDisabled && dispatch({
            type: SET_TILE_VIEW,
            enabled
        });
    };
}
/**
 * Set số lượng người cho tile-view
 * @param mode  4 | 9 | 16 | 25
 * @returns
 */
export function setTileViewMode(mode) {
    return (dispatch, getState) => {
        dispatch({
            type: SET_TILE_VIEW_MODE,
            mode
        });
    };
}
/**
 * Creates a (redux) action which signals either to exit tile view if currently
 * enabled or enter tile view if currently disabled.
 *
 * @returns {Function}
 */
export function toggleTileView() {
    return (dispatch, getState) => {
        const tileViewActive = shouldDisplayTileView(getState());
        if (!tileViewActive) {
            dispatch(setVisibleRemoteParticipants(0, (TILE_VIEW_PARTICIPANT - 1)));
        }
        setTimeout(() => {
            dispatch(setTileView(!tileViewActive));
        }, 1000);
    };
}
export function setFilmstripMode(mode) {
    return {
        type: SET_FILMSTRIP_VIEW_MODE,
        mode
    };
}
